import { Button, Stack, Typography } from '@mui/material'
import React from 'react'
import BillingContactDialog from './dialogs/BillingContactDialog';
import { getTranslation } from "common";
import { useTranslations } from 'hooks';
import FlowentiButton from './flowenti-ui-kit/FlowentiButton';

const CustomBillingButton = () => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const translations = useTranslations();

    const handleDialogClose = () => {
        setDialogOpen(false);
    }

    return (
        <Stack alignItems="center" display="flex" flexDirection="row" spacing={2}>
            <Typography
                variant="h6"
                sx={{
                    textAlign: "center"
                }}
                marginRight={2}
                marginTop="10px"
            >
                {getTranslation(translations, "billing_support.text")}
            </Typography>
            <FlowentiButton
                variant="outlined"
                size="small"
                onClick={() => setDialogOpen(true)}
            >
                {getTranslation(translations, "support.title")}
            </FlowentiButton>
            <BillingContactDialog open={dialogOpen} onClose={handleDialogClose} />
        </Stack>
    )
}

export default CustomBillingButton